// extracted by mini-css-extract-plugin
export default {"PrimaryButton":"ConfirmPopup_PrimaryButton__ZpxDC","SubText":"ConfirmPopup_SubText__HuBZU"};